module.exports = {
  height: {
    value: '100%',
  },
};
